import React, { useEffect, useState } from 'react';
import { Row, Col } from "react-bootstrap";
import { NotificationManager } from 'react-notifications';

import { Fecha, formatBytes, iconos, VerEmail, StatusEmail, ChkEmail } from '../../funciones/EmailFunction';

import CustomModal from "../../components/Modal/CustomModal";

import MailAttachment from './MailAttachment';
import ReplyEmail from './ReplyEmail';
import ForwardEmail from './ForwardEmail';

let replyV = false;
let forwardV = false;

const ViewEmail = (props) => {
    const [contenido, setContenido] = useState([]);
    const [col1, setCol1] = useState(12);
    const [col2, setCol2] = useState(12);
    const [reply, setReply] = useState(false);
    const [forward, setForward] = useState(false);
    const [preloader, setPreloader] = useState({ icono: "fa fa-spinner fa-spin", text: "Cargando contenido del mensaje, espera" })
    const [mensaje, setMensaje] = useState("");
    const [control, setControl] = useState(false);
    const [botonesD, setBotonesD] = useState(true);
    const [botones, setBotones] = useState(true);
    const [colorBotonesD, setColorBotonesD] = useState({
        fontSize: 15, cursor: "not-allowed", color: "9e9e9e"
    });
    const [colorBotones, setColorBotones] = useState({
        fontSize: 15, cursor: "not-allowed", color: "9e9e9e"
    });
    const [openModalConfirm, setOpenModalConfirm] = useState(false);
    const [boton1, setBoton1] = useState({icono: "fa fa-check", texto: "Si", disabled: false});
    const [iconoNoLeido, setIconoNoLeido] = useState ("fa fa-envelope")
    const [iconoSpam, setIconoNoSpam] = useState ("fa fa-ban")

    useEffect(() => {
        setContenido(props.Content);
        if(props.Content.Attachment.length > 0) {
            setCol1(9)
            setCol2(3)
        }

        let respOk = (resp) => {
            let mess = resp.data[0].Mess
            if (resp.data[0].Mess === "") mess = resp.data[0].MessP
            setMensaje(mess)
            setControl(!control)
            setPreloader({ icono: "", text: "" })
            setBotonesD(false)
            setBotones(false)
            setColorBotonesD({
                fontSize: 15, cursor: "pointer", color: "bf0000"
            })
            setColorBotones({
                fontSize: 15, cursor: "pointer", color: "4aa6a6"
            })
        }

        /* Primer Intento */
        VerEmail (props.Content.UId, props.Content.Date, props.Email, (resp1) => {
            if (resp1.status === "error"){
                setPreloader({ icono: "fa fa-spinner fa-spin", text: "Cargando contenido del mensaje. Segundo intento, espera" })
                /* Segundo Intento */
                VerEmail (props.Content.UId, props.Content.Date, props.Email, (resp2) => {
                    if (resp2.status === "error"){
                        setPreloader({ icono: "fa fa-spinner fa-spin", text: "Cargando contenido del mensaje. Tercer intento, espera" })
                        /* Tercer Intento */
                        VerEmail (props.Content.UId, props.Content.Date, props.Email, (resp3) => {
                            if (resp3.status === "error"){
                                /* Conexión Fallida */
                                setPreloader({ icono: "fa fa-times", text: "Ocurrió un error al cargar el mensaje" })
                                NotificationManager.error(resp3.mess);
                            }else{
                                respOk(resp3)
                            }
                        })
                    }else{
                        respOk(resp2)
                    }
                })
            }else{
                respOk(resp1)
            }
        })
    }, []);

    let styles2 = {
        cursor: "pointer",
        fontSize: 16,
        color: "f6a72f"
    }

    let adjuntos = () => {
        let adjunto = props.Content.Attachment
        if(adjunto.length === 0) return null;
        
        let archivos = () => (
            adjunto.map(option => (
                <MailAttachment
                    key = {(Math.random() * 999999) + 1}
                    FileName = {option.Name} 
                    Email = {props.Email}
                    Date = {contenido.Date}
                    UId = {contenido.UId}
                    Icono = {iconos(option.Subtype, "icono")}
                    Color = {iconos(option.Subtype, "color")}
                    Name = {/* ( */option.Name/* ).substr(0,25) */}
                    Size = {formatBytes(option.Bytes)}
                    Contenido = {option}
                />
            ))
        )

        return (
            <div style={{backgroundColor:"f2f4f8", boxShadow:"inset 2px 2px 1px #CCC", borderRadius:"4px 4px",
            height: "53vh", overflowY: "auto", overflowX: "hidden", padding: 5}}>
                <div style={{fontSize: 12}}><i className="fa fa-paperclip"></i> Archivos Adjuntos:</div>
                {archivos()}
            </div>
        )
    }

    let responder = ()=> {
        if (botonesD === true) return null
        replyV = true; setReply(true)
    }

    let reenviar = ()=> {
        if (botones === true) return null
        forwardV = true; setForward(true)
    }

    let respOk2 = (data, correo, mensaje) => {
        props.funcion2()
        props.funcion()
        NotificationManager.info(mensaje);
        setOpenModalConfirm(false)
        setControl(!control)
    }

    let Delete = () => {
        if (boton1.disabled === true) return null
        setBoton1({icono: "fa fa-spinner fa-spin", texto: "Espera", disabled: true})
        StatusEmail (props.Email, contenido.UId, "Delete", (resp) => {
            if (resp.tipo === "info"){
                ChkEmail (props.Email, props.FechaC, (resp1) => {
                    if (resp1.status === "error"){
                        /* Segundo Intento */
                        ChkEmail (props.Email, props.FechaC, (resp2) => {
                            if (resp2.status === "error"){
                                /* Tercer Intento */
                                ChkEmail (props.Email, props.FechaC, (resp3) => {
                                    if (resp3.status === "error"){
                                        /* Conexión Fallida */
                                        NotificationManager.error(resp3.mess);
                                        setBoton1({icono: "fa fa-check", texto: "Si", disabled: false})
                                        setOpenModalConfirm(false)
                                        setControl(!control)
                                    }else{
                                        respOk2(resp3, props.Email, "Mensaje Eliminado")
                                    }
                                })
                            }else{
                                respOk2(resp2, props.Email, "Mensaje Eliminado")
                            }
                        })
                    }else{
                        respOk2(resp1, props.Email, "Mensaje Eliminado")
                    }
                })
            }else{
                NotificationManager.error(resp.text);
                setBoton1({icono: "fa fa-check", texto: "Si", disabled: false})
                setOpenModalConfirm(false)
                setControl(!control)
            }
        })
    }

    let modalConfirm = () => (
        <CustomModal
            boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
            boton1 = {<React.Fragment><i className={boton1.icono}></i> {boton1.texto}</React.Fragment>}
            large = "medium"
            isopen =  {openModalConfirm}
            titulo = "Confirmación"
            contenido = {<div>¿Deseas <strong>Eliminar</strong> el mensaje de la bandeja?</div>}      
            funcion1 = {() => {
                Delete()
            }}
            funcion2 = {() => {
                if (boton1.disabled === true) return null
                setOpenModalConfirm(false)
            }}
        />
    )

    let NoLeido = () => {
        if (botones === true || botonesD === true) return null

        setBotonesD(true);
        setBotones(true);
        setIconoNoLeido("fa fa-spinner fa-spin")
        setColorBotonesD({
            fontSize: 15, cursor: "not-allowed", color: "9e9e9e"
        });
        setColorBotones({
            fontSize: 15, cursor: "not-allowed", color: "9e9e9e"
        });

        StatusEmail (props.Email, contenido.UId, "UnSeen", (resp) => {
            if (resp.tipo === "info"){
                ChkEmail (props.Email, props.FechaC, (resp1) => {
                    if (resp1.status === "error"){
                        /* Segundo Intento */
                        ChkEmail (props.Email, props.FechaC, (resp2) => {
                            if (resp2.status === "error"){
                                /* Tercer Intento */
                                ChkEmail (props.Email, props.FechaC, (resp3) => {
                                    if (resp3.status === "error"){
                                        /* Conexión Fallida */
                                        NotificationManager.error(resp3.mess);
                                        setBotonesD(false);
                                        setBotones(false);
                                        setIconoNoLeido("fa fa-envelope")
                                        setColorBotonesD({
                                            fontSize: 15, cursor: "pointer", color: "bf0000"
                                        });
                                        setColorBotones({
                                            fontSize: 15, cursor: "pointer", color: "4aa6a6"
                                        });

                                        setControl(!control)
                                    }else{
                                        respOk2(resp3, props.Email, "Estatus Cambiado")
                                    }
                                })
                            }else{
                                respOk2(resp2, props.Email, "Estatus Cambiado")
                            }
                        })
                    }else{
                        respOk2(resp1, props.Email, "Estatus Cambiado")
                    }
                })
            }else{
                NotificationManager.error(resp.text);
                setBoton1({icono: "fa fa-check", texto: "Si", disabled: false})
                setControl(!control)
            }
        });
    }

    let ToSpam = () => {
        if (botones === true || botonesD === true) return null

        setBotonesD(true);
        setBotones(true);
        setIconoNoSpam("fa fa-spinner fa-spin")
        setColorBotonesD({
            fontSize: 15, cursor: "not-allowed", color: "9e9e9e"
        });
        setColorBotones({
            fontSize: 15, cursor: "not-allowed", color: "9e9e9e"
        });

        StatusEmail (props.Email, contenido.UId, "Spam", (resp) => {
            if (resp.tipo === "info"){
                ChkEmail (props.Email, props.FechaC, (resp1) => {
                    if (resp1.status === "error"){
                        /* Segundo Intento */
                        ChkEmail (props.Email, props.FechaC, (resp2) => {
                            if (resp2.status === "error"){
                                /* Tercer Intento */
                                ChkEmail (props.Email, props.FechaC, (resp3) => {
                                    if (resp3.status === "error"){
                                        /* Conexión Fallida */
                                        NotificationManager.error(resp3.mess);
                                        setBotonesD(false);
                                        setBotones(false);
                                        setIconoNoSpam("fa fa-ban")
                                        setColorBotonesD({
                                            fontSize: 15, cursor: "pointer", color: "bf0000"
                                        });
                                        setColorBotones({
                                            fontSize: 15, cursor: "pointer", color: "4aa6a6"
                                        });

                                        setControl(!control)
                                    }else{
                                        respOk2(resp3, props.Email, "Mensaje Movido")
                                    }
                                })
                            }else{
                                respOk2(resp2, props.Email, "Mensaje Movido")
                            }
                        })
                    }else{
                        respOk2(resp1, props.Email, "Mensaje Movido")
                    }
                })
            }else{
                NotificationManager.error(resp.text);
                setBoton1({icono: "fa fa-check", texto: "Si", disabled: false})
                setControl(!control)
            }
        });
    }

    let ViewM = () => (
        <React.Fragment>
            <Row style={{paddingLeft: 10, paddingRight: 10}}>
                <div className="custom-alert-info" style={{backgroundColor:"fff", minHeight: 45, boxShadow:"2px 2px 4px #CCC", padding: 5}}>
                    <Row>
                        <Col md={7} xs={12}>
                            <div><strong>{contenido.Title}</strong></div>
                            <div className="text-muted" style={{fontSize: 11}}>{`De: ${contenido.Sender}`}</div>
                        </Col>
                        <Col md={5} xs={12} align="right">
                            <button className="btn btn-default" onClick={()=> {props.funcion()}} style={{borderWidth: 0, padding: "5px 0px 5px 0px"}}>
                                <i title="Volver a la lista de mensajes" className="fa fa-arrow-circle-left" style={styles2}></i>
                            </button>
                            <button className="btn btn-default" onClick={responder} style={{marginLeft: 5, borderWidth: 0, padding: "5px 0px 5px 0px"}}>
                                <i title="Responder" className="fa fa-reply" style={colorBotonesD}></i>
                            </button>
                            <button className="btn btn-default" onClick={reenviar} style={{marginLeft: 5, borderWidth: 0, padding: "5px 0px 5px 0px"}}>
                                <i title="Reenviar" className="fa fa-mail-forward" style={colorBotones}></i>
                            </button>
                            <button className="btn btn-default" onClick={ToSpam} style={{marginLeft: 5, borderWidth: 0, padding: "5px 0px 5px 0px"}}>
                                <i title="Mover a la carpeta Spam" className={iconoSpam} style={colorBotones}></i>
                            </button>
                            <button className="btn btn-default" onClick={()=>{
                                if (botones === true || botonesD === true) return null
                                setOpenModalConfirm(true)
                            }} style={{marginLeft: 5, borderWidth: 0, padding: "5px 0px 5px 0px"}}>
                                <i title="Eliminar" className="fa fa-trash" style={colorBotones}></i>
                            </button>
                            <button className="btn btn-default" onClick={NoLeido} style={{marginLeft: 5, borderWidth: 0, padding: "5px 0px 5px 0px"}}>
                                <i title="Marcar como No Leido" className={iconoNoLeido} style={colorBotones}></i>
                            </button>
                            {/* <i title="Destacar" className="fa fa-star-o" style={colorBotones}></i> */}
                            <div style={{fontSize: 11, marginTop: 10}} className="text-muted"><i className="fa fa-clock-o"></i> {Fecha(contenido.Date)}</div>
                        </Col>
                    </Row>
                </div>
            </Row>
            <Row className="custom-mt-10" style={{left: 15, right: 15, position:"absolute", backgroundColor:"fff",
                height: "57vh", overflowY: "auto", overflowX: "hidden", borderTop: "1px solid #ededed", borderBotton: "1px solid #ededed"}}>
                <Col md={col1} className="custom-mt-10">
                    <div align="center" style={{padding: 10}} className="text-danger"><i className={preloader.icono}></i> {preloader.text}</div>
                    <div dangerouslySetInnerHTML={{ __html: mensaje }}></div>
                </Col>
                <Col md={col2} className="custom-mt-10">
                    {adjuntos()}
                </Col>
            </Row>
            {modalConfirm()}
        </React.Fragment>
    )
    switch (true){
        case (reply === true): return <ReplyEmail Mess = {mensaje} contenido = {contenido} funcion = {()=> {replyV = false; setReply(false)}} Remitente = {props.FullEmail}/>
        case (forward === true): return <ForwardEmail Mess = {mensaje} adjuntos ={props.Content.Attachment} contenido = {contenido} funcion = {()=> {forwardV = false; setForward(false)}} Remitente = {props.FullEmail}/>
        default: return ViewM()
    }
}

export default ViewEmail;


// WEBPACK FOOTER //
// ./src/views/Email/ViewEmail.jsx